export const reportingAnAccountContent = `If you believe an account is violating any of our guidelines or policies you can report it.

## How to Report a Post

1. Go to the post
2. Tap the **three-dot menu** (···)
3. Select **Report Post**
4. Choose the reason for your report
5. Submit your report


## How to Report an Account

1. Go to the account's **profile page**
2. Tap the **three-dot menu** (···)
3. Select **Report Account**
4. Choose the reason for your report
5. Submit your report

## Blocking and Muting

In addition to reporting, you can:

**Block:** Prevents the account from seeing your content or interacting with you
**Mute:** Hides the account's content from your feeds

These options are available from the same three-dot menu on any post/profile.

If you need further help, contact us at [support@batesky.app](mailto:support@batesky.app).
`
